/**
 * Decode JWT payload (middle segment) without verifying the signature.
 * Used only for UI: tenant picker. Authorization is still enforced by ResiBot on each request.
 */
export function decodeJwtPayload(accessToken) {
  if (!accessToken || typeof accessToken !== "string") return null;
  const parts = accessToken.split(".");
  if (parts.length < 2) return null;
  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const pad = base64.length % 4;
    const padded = base64 + (pad ? "=".repeat(4 - pad) : "");
    const json = atob(padded);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/** Tenant IDs listed in the token (must align with ResiBot api/services/auth._extract_tenant_ids). */
export function getAllowedTenantIdsFromToken(accessToken) {
  const p = decodeJwtPayload(accessToken);
  if (!p || typeof p !== "object") return [];
  const out = new Set();
  for (const key of ["tenant_id", "tenantId"]) {
    const v = p[key];
    if (typeof v === "string" && v.trim()) out.add(v.trim().toLowerCase());
  }
  for (const key of ["tenant_ids", "tenantIds"]) {
    const arr = p[key];
    if (Array.isArray(arr)) {
      arr.forEach((x) => {
        if (typeof x === "string" && x.trim()) out.add(x.trim().toLowerCase());
      });
    }
  }
  return [...out];
}
